
export default [
	{
		text: 'Camps are where conversations happen. Jump in and introduce yourself and your business, ask a question or share what you’re working on today.',
		selector: '#campList',
		position: 'right',
	},
	{
		text: 'Don’t see a camp that’s right for you? Suggest one here and we’ll make it for you.',
		selector: '#newCamp',
		position: 'right'
	},
	{
		text: 'This list are all the things you’ve said you want to learn more about. Click on one to easily navigate and get started!',
		selector: '#interestsList',
		position: 'bottom',
	},
	{
		text: 'Here are a few camps we think you might like to join. We base this on your interests. Jump in and join the conversation!',
		selector: '#suggestedCamps',
		position: 'bottom'
	},
	{
		text: 'Your feed is where all the activity in your camps and from your interests comes together. This is the most recent post from a camp you’re a part of.',
		selector: '#feedList .feed-item:first-child',
		position: 'top',
	}
]



// WEBPACK FOOTER //
// ./src/js/components/Onboarding/steps/community.js